import { MONTHS } from "@/shared/utils/dateHelpers";
import { fmtAUD } from "@/shared/utils/formatCurrency";

export function buildInsights({ monthExpenses, monthIncome, savingsRate, pieData, expByGroup, currentBudgets, expenseMap, prevExpenses, prevExpByGroup, prevMonth }) {
  const alerts = [];
  const trends = [];

  if (prevExpenses > 0 && monthExpenses > 0) {
    const pctChange = ((monthExpenses - prevExpenses) / prevExpenses) * 100;
    if (Math.abs(pctChange) > 3) {
      trends.push({
        icon: pctChange > 0 ? "\u{1F4C8}" : "\u{1F4C9}",
        color: pctChange > 0 ? "#ef4444" : "#16a34a",
        text:
          "Total spending is " +
          (pctChange > 0 ? "up" : "down") +
          " " +
          Math.abs(pctChange).toFixed(0) +
          "% vs " +
          MONTHS[prevMonth].slice(0, 3) +
          " ($" +
          fmtAUD(prevExpenses) +
          " then, $" +
          fmtAUD(monthExpenses) +
          " now)",
      });
    }
  }

  if (pieData.length > 0) {
    const top = pieData.reduce((a, b) => (a.value > b.value ? a : b));
    const topPct =
      monthExpenses > 0 ? ((top.value / monthExpenses) * 100).toFixed(0) : 0;
    trends.push({
      icon: "\u{1F3AF}",
      color: "#2563eb",
      text:
        "Top category: " +
        top.name +
        " at $" +
        fmtAUD(top.value) +
        " (" +
        topPct +
        "% of expenses)",
    });
  }

  Object.keys(expenseMap).forEach((group) => {
    const gBudget = (expenseMap[group] || []).reduce(
      (s, c) => s + (Number(currentBudgets[c]) || 0),
      0
    );
    const gActual = Number(expByGroup[group]) || 0;
    if (gBudget > 0 && gActual > gBudget) {
      alerts.push({
        icon: "\u{26A0}\u{FE0F}",
        color: "#ef4444",
        text:
          String(group) +
          " is $" +
          fmtAUD(gActual - gBudget) +
          " over budget ($" +
          fmtAUD(gActual) +
          " of $" +
          fmtAUD(gBudget) +
          ")",
      });
    }
  });

  const groupChanges = Object.keys(expenseMap)
    .map((g) => ({
      group: g,
      current: expByGroup[g] || 0,
      prev: prevExpByGroup[g] || 0,
      diff: (expByGroup[g] || 0) - (prevExpByGroup[g] || 0),
    }))
    .filter((x) => x.prev > 0 && Math.abs(x.diff) > 20)
    .sort((a, b) => b.diff - a.diff);

  if (groupChanges.length > 0 && groupChanges[0].diff > 0) {
    const g = groupChanges[0];
    trends.push({
      icon: "\u{1F525}",
      color: "#f59e0b",
      text:
        String(g.group) +
        " jumped $" +
        fmtAUD(g.diff) +
        " vs last month ($" +
        fmtAUD(g.prev) +
        " to $" +
        fmtAUD(g.current) +
        ")",
    });
  }

  if (monthIncome > 0) {
    if (savingsRate >= 20) {
      trends.push({
        icon: "\u{1F389}",
        color: "#16a34a",
        text:
          "Great job! You're saving " +
          savingsRate.toFixed(0) +
          "% of your income this month",
      });
    } else if (savingsRate > 0) {
      trends.push({
        icon: "\u{1F4A1}",
        color: "#f59e0b",
        text:
          "You're saving " +
          savingsRate.toFixed(0) +
          "% this month. Aim for 20%+ to hit your deposit goal faster",
      });
    } else {
      trends.push({
        icon: "\u{26A0}\u{FE0F}",
        color: "#ef4444",
        text: "You're spending more than you earn this month. Review your expenses to find savings",
      });
    }
  }

  return { alerts, trends };
}
